import { Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { Spinner } from '../spinner';
import SpinFC from 'antd/lib/spin';
import ContentLoader from 'react-content-loader';
interface prop {
  listItems: { label: string; value: string }[];
  setSearch: React.Dispatch<React.SetStateAction<string>>;
  loading?: boolean;
  submitValue: React.Dispatch<React.SetStateAction<string>>;
}
const SearchableDropdown = ({
  listItems,
  setSearch,
  loading,
  submitValue,
}: prop) => {
  const [open, setOpen] = useState<boolean>(false);
  const [value, setValue] = useState<string>('');
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
    setValue(event.target.value);
    setOpen(true);
  };
  const handleOnOptionClick = (data: { label: string; value: string }) => {
    setValue(data.label);
    submitValue(data.value);
    setOpen(false);
  };
  const handleBlur = () => {
    setTimeout(() => {
      setOpen(false);
    }, 200); // Small delay to allow click to register
  };

  return (
    <div className="searchable-select-container">
      <input
        onFocus={() => setOpen(true)}
        onBlur={handleBlur}
        onChange={(event) => handleChange(event)}
        type="text"
        value={value}
        className="searchable-dropdown-input"
        placeholder="Search facilities"
      />
      {open ? (
        <div
          onMouseEnter={() => setOpen(true)}
          className="searchable-dropdown-lists"
        >
          {!loading ? (
            <div
              onClick={() => handleOnOptionClick({ label: 'All', value: '' })}
              className="searchable-dropdown-list-Item"
            >
              All
            </div>
          ) : null}
          {!loading ? (
            listItems?.map((item) => (
              <div
                onClick={() => handleOnOptionClick(item)}
                key={item?.value}
                className="searchable-dropdown-list-Item"
              >
                {item?.label}
              </div>
            ))
          ) : (
            <div className="graph-loader">
              <ContentLoader width={200} height={50} viewBox="0 0 200 200">
                <rect x="0" y="130" rx="2" ry="2" width="27" height="60" />
                <rect x="40" y="115" rx="2" ry="2" width="27" height="75" />
                <rect x="80" y="96" rx="2" ry="2" width="27" height="94" />
                <rect x="120" y="50" rx="2" ry="2" width="27" height="140" />
                <rect x="160" y="112" rx="2" ry="2" width="27" height="78" />
              </ContentLoader>
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
};

export default SearchableDropdown;
